import React from 'react'

export default function DetallesPaciente() {
  return (
    <div>DetallesPaciente</div>
  )
}
